export const INTEGRATION_CONDITION_NAMESPACES = ['context.', 'subscriber.'];
/**
 * Namespaces accepted when evaluating already-persisted rules at send time.
 * `payload.*` is no longer writable, but saved rules such as `payload.region` must still match.
 */
export const INTEGRATION_CONDITION_RUNTIME_NAMESPACES = [...INTEGRATION_CONDITION_NAMESPACES, 'payload.'];
export const INTEGRATION_CONDITION_VARIABLES = [
    'context.tenant.id',
    'subscriber.subscriberId',
    'subscriber.email',
    'subscriber.phone',
    'subscriber.firstName',
    'subscriber.lastName',
    'subscriber.locale',
    'subscriber.data',
    'workflow.workflowId',
    'workflow.name',
    'workflow.description',
    'workflow.tags',
    'workflow.severity',
];
//# sourceMappingURL=integration-conditions.js.map